import React from 'react';
import { Container, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckCircleOutline';

const values = [
  'We are pragmatists – always solving business problems, not academic ones.',
  'Client-first approach – no stupid questions, we build confidence and comfort.',
  'We are educators – our solutions are understandable and explainable.',
  'Fast & iterative – we ship value quickly, perfectionism kills progress.',
  'Curiosity is our driver – constant exploration fuels innovation.',
  'We seek hard problems – difficult challenges yield high-impact results.',
];

export default function WhyChooseUs() {
  return (
    <Container sx={{ py: 8, color: 'common.white' }}>
      <Typography variant="h2" component="h2" align="center" color="secondary.main" gutterBottom>
        Why Choose Us
      </Typography>
      <List sx={{ maxWidth: 800, mx: 'auto' }}>
        {values.map((item) => (
          <ListItem key={item} sx={{ alignItems: 'flex-start' }}>
            <ListItemIcon>
              <CheckIcon color="secondary" />
            </ListItemIcon>
            <ListItemText
              primary={item}
              primaryTypographyProps={{ color: 'common.white' }}
            />
          </ListItem>
        ))}
      </List>
    </Container>
  );
}
